import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'js/withRouter';
import { legacyInjectIntl } from 'js/wrapper/injectIntl';
import { S3_LINKS_DIV } from 'js/constants';

class EditionPreviews extends React.Component {
  static defaultProps = {
    editionPreviews: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      showPreview: EditionPreviews.getPrimaryPreviewKey(props.editionPreviews),
    };
  }

  static getPrimaryPreviewKey(editionPreviews = []) {
    if (typeof editionPreviews[0] !== 'undefined' && editionPreviews[0].key) {
      return editionPreviews[0].key;
    }

    return S3_LINKS_DIV.TEMPLATE_INITIAL_PREVIEW;
  }

  componentDidUpdate(prevProps) {
    const prevKey = EditionPreviews.getPrimaryPreviewKey(prevProps.editionPreviews);
    const nextKey = EditionPreviews.getPrimaryPreviewKey(this.props.editionPreviews);

    if (prevKey !== nextKey && this.state.showPreview !== nextKey) {
      this.setState({ showPreview: nextKey });
    }
  }

  changePreview = key => {
    this.setState({
      showPreview: key,
    });
  };

  checkIsVideo = type => {
    if (type === '000000000000000000000004') {
      return true
    }
  }

  render() {
    const { editionPreviews, editionId, type } = this.props;

    const { showPreview } = this.state;

    const previews =
      editionPreviews.length > 0
        ? editionPreviews
        : [
            {
              key: S3_LINKS_DIV.TEMPLATE_INITIAL_PREVIEW,
            }
          ];

    return (
      <div key={editionId} className="preview row">
        <div className="preview-image">
          <div className="preview-wrap">
            {this.checkIsVideo(type) === true ?
              <video src={showPreview} />
                :
              <img src={showPreview} />
            }
          </div>
        </div>
        {this.checkIsVideo(type) === true ?
          <></>
          :
          <div className="preview-thumbs">
            {previews.map((preview, i) => {
              if (i < 3) {
                if (preview.key !== showPreview) {
                  return (
                    <div
                      key={'preview-thumb-' + preview?.key + preview?.id}
                      className="preview-thumb"
                      onClick={() => {
                        this.changePreview(preview.key);
                      }}
                    >
                      <img
                        src={preview.key}
                        alt={'Preview ' + i}
                      />
                    </div>
                  );
                }
                return (
                  <div key={'preview-thumb-' + preview?.key + preview?.id} className="preview-thumb active">
                    <img
                      src={ preview.key}
                      alt={'Preview ' + i}
                    />
                  </div>
                );
              }
            })}
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

export default withRouter(legacyInjectIntl(connect(mapStateToProps)(EditionPreviews)));
